var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feed-page"},[_c('header-mobile-page',{attrs:{"label":"Family Feed"}}),_c('Feed',{staticClass:"feed"}),(this.$mq === 'mobile')?_c('router-link',{staticClass:"overview-feed-link",attrs:{"to":{ name: 'overview' }}},[_c('base-fab',{attrs:{"icon":"icon-overview","iconColor":"#fff"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }